module.exports = __webpack_public_path__ + "static/media/example.d4f5f1ff.gif";